import React from 'react';
import { Reveal } from '@/components/public';

/**
 * IntegrationsStrip — light-gray band directly under the red marquee.
 * Shows the POS / hardware / payment tools Hungry Canadian connects with.
 * Logos are grayscale by default and animate to full colour on hover.
 *
 * Logos are bundled with the app (served from /public) so the site has no
 * runtime dependency on the merchants.hungrycanadian.com asset bucket.
 */
const LOGO_BASE = `${process.env.PUBLIC_URL || ''}/integration-logos`;

const INTEGRATIONS = [
  { name: 'Square', src: `${LOGO_BASE}/square.svg`, alt: 'Square POS' },
  { name: 'Lightspeed', src: `${LOGO_BASE}/lightspeed.svg`, alt: 'Lightspeed Commerce POS' },
  { name: 'Clover', src: `${LOGO_BASE}/clover.svg`, alt: 'Clover POS' },
  { name: 'Shopify POS', src: `${LOGO_BASE}/shopify.svg`, alt: 'Shopify POS' },
  { name: 'Stripe', src: `${LOGO_BASE}/stripe.svg`, alt: 'Stripe payment processing' },
  { name: 'Deliverect', src: `${LOGO_BASE}/deliverect.svg`, alt: 'Deliverect order integration' },
  { name: 'EPOS Now', src: `${LOGO_BASE}/epos-now.svg`, alt: 'EPOS Now POS' },
];

export default function IntegrationsStrip() {
  return (
    <section
      data-testid="integrations-strip"
      className="w-full bg-muted/60 border-b border-border py-8 md:py-10 px-4 sm:px-6"
    >
      <div className="max-w-6xl mx-auto">
        <Reveal>
          <p className="text-center text-xs md:text-sm font-semibold uppercase tracking-[0.2em] text-muted-foreground mb-6 md:mb-8">
            Seamlessly connects with the tools you already use:
          </p>
        </Reveal>

        <Reveal delay={0.08}>
          <ul className="flex flex-wrap items-center justify-center gap-x-6 gap-y-6 sm:gap-x-8 md:gap-x-12">
            {INTEGRATIONS.map((logo) => (
              <li
                key={logo.name}
                data-testid={`integration-logo-${logo.name.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
                className="group flex items-center justify-center h-9 md:h-10 w-24 sm:w-28 md:w-32"
              >
                <img
                  src={logo.src}
                  alt={logo.alt}
                  loading="lazy"
                  decoding="async"
                  draggable={false}
                  className="max-h-full max-w-full object-contain grayscale opacity-60 transition-[filter,opacity] duration-300 group-hover:grayscale-0 group-hover:opacity-100"
                />
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
    </section>
  );
}
